import { Panel, Pill } from "@/components/admin/AdminUI";
import StoreSection from "@/components/admin/StoreSection";
import { formatDate, humanize } from "@/lib/format";

export default function PurchasesTab({ data }) {
  const ledger = data.super_crush_ledger || [];
  const purchases = data.purchases || [];
  return (
    <div className="space-y-6">
      <StoreSection store={data.store} />
      <Panel className="p-6" data-testid="user-purchases">
        <h2 className="mb-3 font-semibold">All purchases ({purchases.length})</h2>
        {purchases.length ? <ul className="divide-y divide-border text-sm">{purchases.map((p) => (
          <li key={p.id} className="flex flex-wrap items-center gap-3 py-2.5" data-testid={`user-purchase-${p.id}`}>
            <span className="min-w-0 flex-1">{humanize(p.kind)} · <span className="font-mono text-xs">{p.product_id}</span>{p.offer_id && <span className="cw-muted block text-xs">offer {p.offer_id}{p.promotion_id ? ` · promotion ${p.promotion_id}` : ""}</span>}</span>
            <span className="tabular-nums">{p.display_price || (p.price_usd != null ? `$${p.price_usd}` : "")}</span>
            {(p.mock || p.store === "mock") && <Pill>Mock</Pill>}
            <span className="cw-muted w-40 text-right text-xs">{formatDate(p.created_at)}</span>
          </li>))}</ul> : <p className="cw-muted text-sm">No purchases.</p>}
      </Panel>
      <Panel className="p-6" data-testid="user-super-crush-ledger">
        <h2 className="mb-3 font-semibold">Super Crush ledger (latest 50)</h2>
        {ledger.length ? <ul className="divide-y divide-border text-sm">{ledger.map((x, i) => (
          <li key={i} className="flex items-center gap-3 py-2">
            <span className={`w-12 font-semibold tabular-nums ${x.delta > 0 ? "cw-success" : ""}`}>{x.delta > 0 ? `+${x.delta}` : x.delta}</span>
            <span className="min-w-0 flex-1">{humanize(x.reason)}{x.lane ? <span className="cw-muted"> · {x.lane}</span> : ""}</span>
            <span className="cw-muted text-xs">{formatDate(x.created_at)}</span>
          </li>))}</ul> : <p className="cw-muted text-sm">No ledger entries.</p>}
      </Panel>
    </div>
  );
}
